import { render } from "./PersonSectionAddress.vue?vue&type=template&id=2d1e6822"
import script from "./PersonSectionAddress.vue?vue&type=script&lang=js"
export * from "./PersonSectionAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__